'use client'

import { useEffect, useRef, useState } from 'react'
import { usePathname } from 'next/navigation'
import { pricingTiersByAile, type HesapAilesi } from '../data/pricing'

export function usePublicShell() {
  const pathname = usePathname()
  return { isHome: pathname === '/', isLogin: pathname === '/login', pathname }
}

export function useHeaderAfterStory() {
  const [afterStory, setAfterStory] = useState(false)
  useEffect(() => {
    const history = document.getElementById('history')
    const sequence = document.getElementById('accounting-sequence')
    if (!history || !sequence) return
    let frame = 0
    const update = () => {
      cancelAnimationFrame(frame)
      frame = requestAnimationFrame(() => {
        const story = sequence.offsetHeight ? sequence : history
        setAfterStory(story.getBoundingClientRect().bottom < window.innerHeight - 2)
      })
    }
    const observer = new ResizeObserver(update)
    observer.observe(history)
    observer.observe(sequence)
    window.addEventListener('scroll', update, { passive: true })
    window.addEventListener('resize', update)
    update()
    return () => {
      cancelAnimationFrame(frame)
      observer.disconnect()
      window.removeEventListener('scroll', update)
      window.removeEventListener('resize', update)
    }
  }, [])
  return afterStory
}

export function useLandingMenu() {
  const [open, setOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const close = () => setOpen(false)
  useEffect(() => {
    if (!open) return
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { setOpen(false); buttonRef.current?.focus() }
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])
  return { open, close, buttonRef, toggle: () => setOpen(value => !value) }
}

export function usePricing() {
  const [family, setFamily] = useState<HesapAilesi>('MUSAVIR')
  return { family, setFamily, tiers: pricingTiersByAile[family] }
}

const examples = {
  receipt: { title: 'Masraf fişi', fields: [['Belge numarası', '000128'], ['Tarih', '05.09.2026'], ['KDV tutarı', '208,33 TL'], ['Toplam', '1.250,00 TL']], note: 'Fişteki tarih, belge numarası ve tutarlar kontrolünüz için alanlara aktarılır.' },
  zreport: { title: 'Z raporu', fields: [['Z numarası', '0042'], ['Tarih', '05.09.2026'], ['Nakit satış', '3.500,00 TL'], ['Kartlı satış', '8.250,00 TL']], note: 'Gün sonu raporundaki satış ve ödeme bilgileri birlikte incelenir.' },
}
export function useDocumentExample() {
  const [selected, setSelected] = useState<'receipt' | 'zreport'>('receipt')
  return { selected, setSelected, example: examples[selected] }
}
